import { cn } from "@/lib/utils";

// Official header artwork from https://www.ternrewards.com/; the dark
// background keeps its original gradient legible at compact sizes.
export function TernBrand({
  large = false,
  className,
}: {
  large?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center rounded-md bg-[#073B4C] px-2.5 py-1.5 align-middle",
        large && "rounded-xl px-5 py-3",
        className,
      )}
    >
      <img
        src="/brands/tern-wordmark.svg"
        alt="Tern"
        width={893}
        height={280}
        className={large ? "h-9 w-auto" : "h-5 w-auto"}
      />
    </span>
  );
}
